import styled from "@emotion/styled"
import CustomLink from "../../custom-link/custom-link.component"
import { Typography } from "@mui/material"
import CustomButton from "../../custom-button/custom-button.component"

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  top: ${({ theme }) => theme.navHeight}px;
  z-index: 104;
  background-color: ${({ theme }) => theme.palette.tertiary.light};
  padding: 2.5rem 1.5rem 1.75rem 1rem;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: none;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 1rem;
`

export const LinkWrapper = styled.div`
  cursor: pointer;
`

export const Link = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: 2rem;
  font-weight: 600;
  line-height: normal;
  &.subitem {
    font-size: 1.5rem;
    margin-left: 1.5rem;
  }
`

export const StyledText = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: 2rem;
  font-weight: 600;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  > svg {
    width: 28px;
    height: 28px;
  }
`

export const ContactTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`

export const Contact = styled.a`
  display: block;
  font-size: ${({ theme }) => theme.typography.pxToRem("15")};
  text-decoration: none;
  color: ${({ theme }) => theme.palette.text.primary};
  line-height: 1.5rem;
`

export const StyledBtn = styled(CustomButton)`
  margin-top: 0.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const SubmitBtn = styled(CustomButton)`
  width: 100%;
  margin-top: 1.5rem;
  &.light {
    background-color: transparent;
    border-color: #d1e1ff;
  }
`
